import { ENVIRONMENT } from "../constants";
import { QueryParamBinary } from "./types";

interface BuildRouteShareUrlParams {
  fromId: string;
  toId: string;
  project: string;
  stepFreeRoute: boolean;
  routingUserActiveFloor?: { short_name?: string } | null;
}

export const buildRouteShareUrl = ({
  fromId,
  toId,
  project,
  stepFreeRoute,
  routingUserActiveFloor,
}: BuildRouteShareUrlParams) => {
  if (!fromId || !toId || !project) {
    return "";
  }
  const stepFreeQueryParam = `?step_free=${
    stepFreeRoute ? QueryParamBinary.ENABLED : QueryParamBinary.DISABLED
  }`;
  let urlParams = `${fromId}/${toId}`;

  const isUsingFromCurrentLocation = fromId.includes(",");
  const isUsingToCurrentLocation = toId.includes(",");

  if (routingUserActiveFloor?.short_name) {
    if (isUsingFromCurrentLocation)
      urlParams = `${fromId},${routingUserActiveFloor.short_name}/${toId}`;
    if (isUsingToCurrentLocation)
      urlParams = `${fromId}/${toId},${routingUserActiveFloor.short_name}`;
  }

  const re = /^[0-9]+$/;
  const rV = !re.test(fromId) && !re.test(toId) ? "r2" : "r";

  if (ENVIRONMENT === "prod") {
    return `https://livingmap.link/${rV}/${project}/${urlParams}/${stepFreeQueryParam}`;
  }

  return `https://shortlink-api.${ENVIRONMENT}.livingmap.com/v1/${rV}/${project}/${urlParams}/${stepFreeQueryParam}`;
};
